<template lang="html">
  <div>
    <v-card class="card-size">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-row justify="start">
        <v-col cols="12" sm="6" md="3" class="ml-3">
          <v-text-field
            v-model="searchQuery"
            @input="filtrar"
            append-icon="search"
            :label="$t('label.pesquisar')"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="lista"
        :options.sync="pagination"
        :server-items-length="totalPage"
        :no-data-text="$t('label.tabela_sem_conteudo')"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }">
        <template v-slot:item.acoes="{ item }">
          <v-tooltip bottom v-if="canAccessCRUD">
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-0" v-on="on" @click.stop="onEditar(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.editar') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.nome="{ item }" style="overflow-wrap: anywhere;">
          {{ item.nome }}
        </template>
        <template v-slot:item.titulo="{ item }" style="overflow-wrap: break-word;">
          {{ item.titulo }}
        </template>
        <template v-slot:item.descricao="{ item }" style="overflow-wrap: break-word;">
          {{ item.descricao }}
        </template>
        <template v-slot:item.ind_exibir="{ item }">
          {{ item.indExibir ? $t('label.sim') : $t('label.nao') }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '@/common/functions/roles-computed-generator';

export default {
  data() {
    return {
      roleResources: this.$api.role(this.$resource),
      lista: [],
      esperar: false,
      headers: [
        {
          text: '', value: 'acoes', width: '2%', sortable: false,
        },
        {
          text: this.$tc('label.nome', 1), value: 'nome', width: '30%', sortable: true,
        },
        {
          text: this.$tc('label.titulo', 1), value: 'titulo', width: '30%', sortable: true,
        },
        {
          text: this.$tc('label.descricao', 1), value: 'descricao', width: '30%', sortable: true,
        },
        {
          text: this.$tc('label.exibir', 1), value: 'ind_exibir', width: '8%', sortable: true,
        },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  props: {
    title: String,
  },
  computed: {
    ...generateComputed('DIVISAO', [
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    buscar() {
      const params = {
        filtro: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.roleResources.pesquisar(params).then((response) => {
        this.lista = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    onEditar(role) {
      this.$emit('PESQUISA_ROLE_EDITAR', role);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
  },
  mounted() {
  },
};
</script>
